import { basicTask } from "./task";
import { swiperInit } from "./swiper";
const bodyWrap = document.querySelector("body");
const sideNav = document.querySelector(".sidenav-group");
const hamburger = document.querySelector(".hamburger");
const menuMobile = document.querySelector(".mobile-nav-wrap");
const searchWrap = document.querySelector(".search-overlay");


document.addEventListener("DOMContentLoaded", () => {
	const observer = lozad(".lozad", {
		rootMargin: "10px 0px", // syntax similar to that of CSS Margin
		threshold: 0.1, // ratio of element convergence
		enableAutoReload: true, // it will reload the new image when validating attributes changes
	});
	observer.observe();
	window.lozadObserver = observer;
	swiperInit();
	basicTask();
	generalFunction.init();
});

window.addEventListener("resize", function () {
	clearTimeout(resizeTimeout);

	resizeTimeout = setTimeout(() => {
		let width = this.window.innerWidth;
		if (width <= 1200.1) {
			generalFunction.init();
		}
	}, 1000); // 500 milliseconds = 0.5 seconds
});
window.addEventListener("scroll", function () {
	const width = this.window.innerWidth;
	const scrollTop = window.scrollY || document.documentElement.scrollTop;
	if (width >= 1200.1) {
		if (
			document.body.scrollTop > 100 ||
			document.documentElement.scrollTop > 100
		) {
			bodyWrap.classList.add("minimize");
		} else {
			bodyWrap.classList.remove("minimize");
		}
	}
	if (scrollTop > window.innerHeight) {
		sideNav.classList.add("show");
	} else {
		sideNav.classList.remove("show");
	}
});
document.addEventListener("click", (event) => {
	if (!event.target.closest(".search-toggle, .search-overlay")) {
		searchWrap.classList.remove("is-open");
	}
	if (!event.target.closest(".mobile-nav-wrap, .site-menu-toggle")) {
		menuMobile.classList.remove("is-open");
		bodyWrap.classList.remove("overlay-bg");
		hamburger.classList.remove("is-active");
	}
});

Fancybox.bind("[data-fancybox]", {
	parentEl: document.body[0], // Element containing main structure
});



// Scroll handler
// $(window).scroll(function () {
// 	var scrollDistance = $(window).scrollTop();
// 	var headerHeight = $("header").outerHeight();
// 	var offset = headerHeight + 90;

// 	// Find which section is currently in view
// 	$(".home-section-wrap .home-section-id").each(function () {
// 		var sectionId = $(this).attr('id');
// 		var sectionTop = $(this).position().top;
// 		var sectionBottom = sectionTop + $(this).outerHeight();

// 		if (scrollDistance >= sectionTop - offset &&
// 			scrollDistance < sectionBottom - offset) {
// 			// Remove active class from all menu items
// 			$(".nav-primary-menu li.active").removeClass("active");

// 			// Add active class to corresponding menu item
// 			$(".nav-primary-menu a[href='#" + sectionId + "']").parent().parent().addClass("active");
// 			return false; // Break the loop
// 		}
// 	});
// }).scroll();

// // Click handler
// $(".nav-primary-menu a").on("click", function (event) {
// 	if (this.hash !== "") {
// 		event.preventDefault();
// 		var hash = this.hash;
// 		var headerHeight = $("header").outerHeight();

// 		$("html, body").animate(
// 			{
// 				scrollTop: $(hash).offset().top - headerHeight
// 			},
// 			800
// 		);
// 	}
// });




const generalFunction = {
	scrollReveal: () => {
		if ($(window).width() > 1200.1) {
			// Function to process custom attributes
			function revealWithAttributes(selector, baseConfig) {
				document.querySelectorAll(selector).forEach((element) => {
					// Read custom attributes
					const delay = element.getAttribute("data-delay") || baseConfig.delay;
					const duration = element.getAttribute("data-duration") || baseConfig.duration;
					const distance = element.getAttribute("data-distance") || baseConfig.distance;

					// Create a new configuration based on custom attributes
					const config = {
						...baseConfig,
						delay: parseInt(delay, 10),
						duration: parseInt(duration, 10),
						distance: distance,
					};

					// Apply ScrollReveal
					ScrollReveal().reveal(element, { mobile: false, once: true, ...config, easing: "cubic-bezier(0.5, 0, 0, 1)" });

					// Trigger animation for elements already in viewport
					const rect = element.getBoundingClientRect();
					if (rect.top < window.innerHeight && rect.bottom >= 0) {
						ScrollReveal().reveal(element, config);
					}
				});
			}

			// Base configurations
			let fadeDown = { origin: "top", duration: 1000, delay: 200, distance: "20px", interval: 50, reset: false };
			let fadeUp = { origin: "bottom", duration: 1000, delay: 200, distance: "20px", interval: 50, reset: false };
			let fadeLeft = { origin: "left", duration: 1000, delay: 200, distance: "25%", interval: 150, reset: false };
			let fadeRight = { origin: "right", duration: 1000, delay: 200, distance: "25%", interval: 150, reset: false };
			let fadeIn = { origin: "top", duration: 1100, delay: 220, distance: 0, interval: 150, reset: false };

			// Call the function for each selector
			revealWithAttributes(".fd-down", fadeDown);
			revealWithAttributes(".fd-up", fadeUp);
			revealWithAttributes(".fd-left", fadeLeft);
			revealWithAttributes(".fd-right", fadeRight);
			revealWithAttributes(".fd-in", fadeIn);
		}

	},
	hideElement: () => {
		if ($(window).width() < 1200.1) {
			[".searchbox"]
				.map((selector) => document.querySelector(selector))
				.forEach((el) => (el.style.display = "flex"));
		}
	},
	init: () => {
		generalFunction.scrollReveal();
		generalFunction.hideElement();
	},
};



